<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="con"><img src="@/assets/img/设备及原料/合成技术整体解决方案/banner1.png" class="img-fluid"></div>
      <div class="cons"><img src="@/assets/img/设备及原料/合成技术整体解决方案/banner1.png" class="img-fluid"></div>
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
        <p class="desc">擎科生物是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。经过多年的数据和经验积累，以及合成生物学研发和应用平台搭建，公司形成了完善的基因合成产业链服务体系，可提供从合成原料、仪器设备到合成工艺的一物站式解决方案，满足用户在药物基因组学、精准医疗、核酸药物等多方面的需求。
        </p>
        <p class="desc">合成原料：合成试剂、合成单体、修饰单体与CPG、条状分子筛、合成柱等系列产品；</p>
        <p class="desc">合成设备：DNA/RNA系列合成仪，核酸纯化仪、氨解仪等多种合成系列及配套仪器设备；</p>
        <p class="desc">合成工艺：引物合成/疫苗研发/核酸药/DNA&RNA定制化服务等；</p>
        <div class="con" style="width: 100%; margin-top: 40px;"><img src="@/assets/img/设备及原料/合成技术整体解决方案/flow1.jpg" style="width: 100%;"></div>
        <div class="gene_img cons" style="width: 100%; margin-top: 40px;"><img src="@/assets/img/设备及原料/合成技术整体解决方案/flow1.jpg"></div>
      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">擎科优势<small>Tsingke Advantage</small></div>
          <div class="con">
            <div class="neirong" style="display: flex">
              <div class="left ">
                <img src="@/assets/img/设备及原料/合成技术整体解决方案/advantage1.png" class="img-fluid">
              </div>
              <div class="right">
                <div class="required">
                  <p class="mb20">1. 智能高效合成系统，可大幅提高生产效率、降低生产成本;</p>
                  <p class="mb20">2. 合成原料年产量超200吨，200多种核酸合成原材料及耗材，出口韩国、美国及泰国等多个国家和地区;</p>
                  <p class="mb20">3. 拥有超长片段快速基因合成技术服务，可工业化生产160Kb大片段DNA，每年约进行1亿碱基的合成，全国多个城市均有实验基地，便捷服务；</p>
                  <p class="mb20">4. 可为合成生物制造、核酸药物等生物医药企业、科研院所提供全方位的产品和服务。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cons">
            <div class="neirong" style="display: flex">
              <div class="right">
                <div class="required">
                  <p class="mb20">1. 智能高效合成系统，可大幅提高生产效率、降低生产成本;</p>
                  <p class="mb20">2. 合成原料年产量超200吨，200多种核酸合成原材料及耗材，出口韩国、美国及泰国等多个国家和地区;</p>
                  <p class="mb20">3. 拥有超长片段快速基因合成技术服务，可工业化生产160Kb大片段DNA，每年约进行1亿碱基的合成，全国多个城市均有实验基地，便捷服务；</p>
                  <p class="mb20">4. 可为合成生物制造、核酸药物等生物医药企业、科研院所提供全方位的产品和服务。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in serviceList" :key="item.name" class="pointer"
                :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1"
                @click="$router.push(item.ref)">
              <img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="service_chan">
            <li v-for="(item, index) in serviceList" :key="item.name" class="pointer" @click="$router.push(item.ref)">
              <div class="gene_img2">
                <img :src="`/static/img/hx_${item.img}${currentType===index ? '' : '_active'}.png`"
                     style="width: 50px;height: 55px;">
              </div>
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download"
                       v-if="item.resourceFile.fileType === 'PICTURE'"
                       @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download"
                       v-if="item.resourceFile.fileType === 'PICTURE'"
                       @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载
            </el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <qk-consult type="Virus" />
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from '@/components/bread'
export default {
  name: 'IntegratedScheme',
  components: {
    bread
  },
  data() {
    this.serviceList = [
      { name: '基因合成', img: '1', ref: '/tec/gen_compose' },
      { name: '引物合成', img: '2', ref: '/tec/compose1' },
      { name: '修饰合成', img: '3', ref: '/equipment/Modified_synthesis' },
      { name: '化学试剂', img: '6', ref: '/equipment/Chemical_Reagents' }
    ]
    return {
      currentType: -1,
      currentService: -1,
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created() {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns() {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists(id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad(imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile(item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage(value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    }
  }
}
</script>
<style scoped lang="scss">
.service_chan {
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-around;
  li {
    width: 190px;
    height: 188px;
    //margin-right:100px;
    background: url('../../assets/img/产品及服务/fuwu.jpg') no-repeat !important;
    background-size: auto !important;
    .img {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p {
      font-size: 16px;
      color: #4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color: #959595;
      cursor: pointer;
    }
  }
  li:hover {
    background: url('../../assets/img/产品及服务/fuwu1.jpg') no-repeat !important;
    background-size: auto !important;
    p {
      color: #fff;
    }
    .liaojie {
      color: #fff;
    }
  }
  li:last-child {
    margin-right: 0;
  }
}
.download {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e4e6ea;
  li {
    width: 50%;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e6ea;
    border-right: 1px solid #e4e6ea;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-top: 1px solid #e4e6ea;
    }
    &:nth-of-type(2) {
      border-top: 1px solid #e4e6ea;
    }
    &:hover {
      color: #014492;
    }
  }
  .btn-primary {
    font-size: 14px;
    span {
      margin-right: 7px;
    }
  }
  .mr41 {
    display: block;
  }
  .mr42 {
    display: none;
  }
}
.c-title small {
  margin-top: 10px;
}
.required {
  font-size: 18px;
  background: none !important;
  margin-left: 0 !important;
}
.desc {
  font-size: 16px;
}
.effect-lists1,
.effect-lists {
  //display: block!important;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: auto;
}
.compose-type1 {
  padding-bottom: 50px;
  background: url('../../assets/img/产品及服务/基因检测/bg.png') no-repeat;
  background-size: 100% 100%;
}
.effect-lists1 li {
  width: 261px !important;
  height: 262px !important;
}
@media screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width: 400px) {
  .container100 {
    margin-bottom: 20px !important;
  }
  .service_chan {
    justify-content: flex-start !important;
  }
  .effect-lists1 {
    justify-content: center !important;
  }
}
.cons {
  display: none;
}
</style>
<style scoped>
@import url('../../assets/sanger.css');
@import url('../../assets/service.css');
</style>



// WEBPACK FOOTER //
// src/views/equipment/IntegratedScheme.vue